import React from 'react';
import createSvgIcon from './utils/createSvgIcon';

export default createSvgIcon(
  <React.Fragment><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" /><path fill="none" d="M0 0h24v24H0z" /></React.Fragment>
, 'NavigateNext');
